import { defaultMeta } from '@/constants/defaultMeta';
import { parseDateRangeSearch } from '@/lib/parseDateRange';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { chargeSubcategoryQueries } from '@/services/charges/charges.queries';
import { useSearch } from '@tanstack/react-router';

export const useGetSubcategoryList = ({ categoryId }: { categoryId?: string }) => {
  const search = useSearch({ from: '/(app)/configuration-management/charges/$categoryId/' });
  const { sort, page, fetch, createdDate } = search;

  const parsedCreatedDate = parseDateRangeSearch(createdDate, { start: 0, end: 0 });
  const { data, isLoading } = useQuery({
    ...chargeSubcategoryQueries.list({
      row: page ?? 1,
      fetch: fetch ?? 10,
      fromDateMs: parsedCreatedDate?.start ?? 0,
      toDateMs: parsedCreatedDate?.end ?? 0,
      search: search.q ?? '',
      chargeCategoryId: categoryId,
    }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data, sort),
    }),
  });

  return { data: data?.data || [], isLoading, meta: data?.meta.pagination ?? defaultMeta };
};

export const useSubCategoryDetail = ({ chargeSubCategoryId }: { chargeSubCategoryId?: string }) => {
  const { data, isLoading } = useQuery({
    ...chargeSubcategoryQueries.detail(chargeSubCategoryId ?? ''),
    select: (res) => ({
      ...res,
      data: res.data,
    }),
    enabled: Boolean(chargeSubCategoryId),
  });
  return { subCategoryDetail: data?.data, isLoading };
};
